import { c as _c } from "react/compiler-runtime";
import { QRCodeSVG } from 'qrcode.react';
interface Props {
  value: string;
}
export const QRCode = t0 => {
  const $ = _c(2);
  const {
    value
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = <QRCodeSVG value={value} size={103} level="M" fgColor="#111" bgColor="#fff" marginSize={0} title="QR Code upload" />;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};